<div id="list-message" class="content scaffold-list" role="main" *ngIf="student">
    <div class="row">

        <div class="col-sm-3" *ngIf="authService.isGuardian()">
            <app-side-bar-guardian-home [guardian]="guardian"></app-side-bar-guardian-home>
        </div>
        <div class="col-sm-3" *ngIf="authService.isStudent()">
            <app-student-gift-area *ngIf="student.server_user_id!=0" [student]="student"></app-student-gift-area>
        </div>
        <div class="col-sm-9" *ngIf="authService.isStudent() || authService.isGuardian()">
          <a [routerLink]="['/student/messaging/home',student.server_user_id]" class="nav-link active m-2">
          <i class="fa fa-codepen"></i> Received </a>

          <a [routerLink]="['/student/messaging/received',student.server_user_id]" class="nav-link active m-2">
          <i class="fa fa-codepen"></i> Sent </a>

          <a [routerLink]="['/student/messaging/all',student.server_user_id]" class="nav-link active m-2">
          <i class="fa fa-codepen"></i> All </a>
        </div>

    </div>

</div>
